var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11H16C13.2386 11 11 13.2386 11 16V26C11 28.7614 13.2386 31 16 31H26C28.7614 31 31 28.7614 31 26V16C31 13.2386 28.7614 11 26 11Z",
    fill: "#006CB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9567 19.8698C25.0802 20.7021 24.938 21.552 24.5505 22.2988C24.163 23.0456 23.5499 23.6512 22.7984 24.0295C22.0468 24.4077 21.1952 24.5394 20.3645 24.4057C19.5339 24.2721 18.7665 23.8799 18.1716 23.285C17.5767 22.6901 17.1845 21.9227 17.0508 21.092C16.9171 20.2614 17.0488 19.4097 17.4271 18.6582C17.8053 17.9067 18.4109 17.2936 19.1577 16.9061C19.9045 16.5186 20.7545 16.3764 21.5867 16.4998C22.4357 16.6257 23.2216 17.0213 23.8284 17.6281C24.4353 18.235 24.8309 19.0209 24.9567 19.8698Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4567 15H26.4667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.ee517c4424bae9199ad2872b3f28b797.svg";
export { ForwardRef as ReactComponent };